// extracted by mini-css-extract-plugin
module.exports = {"generalStatus":"CampaignForm_generalStatus_2D7kg","details":"CampaignForm_details_-d6qG","title":"CampaignForm_title_1GYjQ"};